<template lang="pug">
.graph(v-scrollbar.y="", @mousemove="handleMousemove")
	.nodes(:style="{height: this.layout.height + 'px'}")
		node(v-for="question in questions", :question="question", :key="question.id", :position="layout.nodePositions[question.id]", @startConnect="startConnect(question, $event)", @finishConnect="finishConnect(question)")
	svg.edges(:style="{height: this.layout.height + 'px'}")
		path(v-for="path, index in edgePaths", :d="path", :key="index")
		path.draggingEdge(:d="draggingEdgePath")
</template>
<script>
import { mapState } from 'vuex'
import Node from './node'

const NODE_HEIGHT = 150
const NODE_WIDTH = 500
const GUTTER_HEIGHT = 100
const GUTTER_WIDTH = 25
export default {
	components: { Node },
	data () {
		return {
			dragConnectFrom: null,
			draggingEdge: null
		}
	},
	computed: {
		...mapState(['start', 'questions']),
		layout () {
			// center axis layout
			// assume fixed node size
			const layout = {
				height: 0,
				nodePositions: {}
			}
			const computeLayout = (previous, question, optionIndex = 0, optionsLength = 1) => {
				let coords
				if (!previous) {
					coords = {
						x: 0,
						y: 0
					}
					layout.height = NODE_HEIGHT
				} else {
					coords = {
						x: previous.x + ((NODE_WIDTH + GUTTER_WIDTH) * optionsLength - GUTTER_WIDTH) * -.5 + (NODE_WIDTH + GUTTER_WIDTH) * optionIndex + NODE_WIDTH / 2,
						y: previous.y + GUTTER_HEIGHT + NODE_HEIGHT
					}
				}
				if (layout.nodePositions[question.id]?.y > coords.y) {
					layout.nodePositions[question.id].x += coords.x
				} else {
					layout.nodePositions[question.id] = coords
					layout.height = coords.y + GUTTER_HEIGHT + NODE_HEIGHT
				}

				if (question.answer.type === 'chooseOne') {
					for (const [index, option] of question.answer.options.entries()) {
						if (option.next) {
							computeLayout(coords, option.next, index, question.answer.options.length)
						}
					}
				}
				if (question.next) {
					computeLayout(coords, question.next)
				}
			}

			computeLayout(null, this.start)
			return layout
		},
		edges () {
			const edges = []
			const computeEdges = (previous, question, optionIndex = 0, optionsLength = 1) => {
				const coords = this.layout.nodePositions[question.id]
				if (previous) {
					edges.push({
						from: {
							x: previous.x - NODE_WIDTH / 2 + NODE_WIDTH / optionsLength * (optionIndex + 1) - NODE_WIDTH / optionsLength / 2,
							y: previous.y + NODE_HEIGHT
						},
						to: {
							x: coords.x,
							y: coords.y
						}
					})
				}
				if (question.answer.type === 'chooseOne') {
					for (const [index, option] of question.answer.options.entries()) {
						if (option.next) {
							computeEdges(coords, option.next, index + 1, question.answer.options.length + 1)
						}
					}
				}
				if (question.next) {
					if (question.answer.type === 'chooseOne') {
						computeEdges(coords, question.next, 0, question.answer.options.length + 1)
					} else {
						computeEdges(coords, question.next)
					}

				}
			}

			computeEdges(null, this.start)
			return edges
		},
		edgePaths () {
			return this.edges.map((edge) => {
				const halfHeight = edge.to.y - 50
				return `M ${edge.from.x} ${edge.from.y} L ${edge.from.x} ${halfHeight} L ${edge.to.x} ${halfHeight} L ${edge.to.x} ${edge.to.y}`
			})
		},
		draggingEdgePath () {
			if (!this.draggingEdge) return
			const edge = this.draggingEdge
			const halfHeight = edge.to.y - 50
			return `M ${edge.from.x} ${edge.from.y} L ${edge.from.x} ${halfHeight} L ${edge.to.x} ${halfHeight} L ${edge.to.x} ${edge.to.y}`
		}
	},
	created () {},
	mounted () {
		document.addEventListener('mouseup', this.handleGlobalMouseup)
	},
	beforeDestroy () {
		document.removeEventListener('mouseup', this.handleGlobalMouseup)
	},
	methods: {
		startConnect (question, connectFrom) {
			this.dragConnectFrom = connectFrom
			this.dragConnectFromQuestion = question
			const nodePosition = this.layout.nodePositions[question.id]
			const optionsLength = question.answer.type === 'chooseOne' ? question.answer.options.length + 1 : 1
			const optionIndex = connectFrom === question ? 0 : question.answer.options.indexOf(connectFrom) + 1
			const coords = {
				x: nodePosition.x - NODE_WIDTH / 2 + NODE_WIDTH / optionsLength * (optionIndex + 1) - NODE_WIDTH / optionsLength / 2,
				y: nodePosition.y + NODE_HEIGHT
			}
			this.draggingEdge = {
				from: coords,
				to: Object.assign({}, coords)
			}
		},
		finishConnect (question) {
			// no selfies
			if (!this.dragConnectFrom || this.dragConnectFromQuestion === question) return
			this.$store.dispatch('connectNext', {
				from: this.dragConnectFrom,
				to: question
			})
		},
		handleMousemove (event) {
			if (!this.dragConnectFrom || event.buttons !== 1) return
			event.preventDefault()
			const boundingRect = this.$el.getBoundingClientRect()
			const mouseCoords = {
				x: event.clientX - boundingRect.left + this.$el.scrollLeft - boundingRect.width / 2,
				y: event.clientY - boundingRect.top + this.$el.scrollTop
			}
			this.draggingEdge.to = mouseCoords
		},
		handleGlobalMouseup () {
			this.dragConnectFrom = null
			this.dragConnectFromQuestion = null
			this.draggingEdge = null
		}
	}
}
</script>
<style lang="stylus">
@import '~settings'
.graph
	margin: 16px 0
	flex: auto
	position: relative
	.edges
		pointer-events: none
		position: absolute
		top: 0
		left: 0
		width: 100%
		path
			transform: translateX(50%)
			stroke: $clr-primary
			fill: none
			stroke-width: 4px
</style>
